import React, { useState } from "react";
import Tab from "../components/Tabs";
import FundCard from "../components/FundCard";
import getFundLogo from "../utils/fundLogos";
import { useQuery, gql } from "@apollo/client";
import "../styles/Insights.css";

const GET_MUTUAL_FUNDS = gql`
  query {
    getMutualFunds {
      id
      amcName
      category
      name
    }
  }
`;

const HomePage = () => {
  const { loading, error, data } = useQuery(GET_MUTUAL_FUNDS); // Correct destructuring
  // Initial State is always all selected
  const [selectedCategory, setSelectedCategory] = useState("Large Cap");
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const funds = data?.getMutualFunds || [];

  // Tab change handler
  const handleTabChange = (key) => {
    setSelectedCategory(key);
  };
  const filteredFunds =
    selectedCategory === "all"
      ? funds
      : funds.filter((fund) => fund.category === selectedCategory);

  return (
    <div className="container mx-auto p-4">
      <Tab onTabChange={handleTabChange} activeKey={selectedCategory} />
      <div className="flex flex-col gap-4 mt-4">
        {filteredFunds.map((fund) => (
          <FundCard
            id={fund.id}
            // image={fund.image}
            name={fund.name}
            type={fund.category}
            amc={fund.amcName}
            logo={getFundLogo(fund.name)}
          />
        ))}
      </div>
    </div>
  );
};

export default HomePage;
